import { createSelector } from 'reselect';
import qs from 'qs';

// @todo in future path this functions use filter init function
import { getRequestQuery } from '../../statistics/shared/utils';
import http from '../http';

import find from 'lodash/find';
import filterBy from 'lodash/filter';
import indexOf from 'lodash/indexOf';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';
import capitalize from 'lodash/capitalize';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import values from 'lodash/values';
import flatten from  'lodash/flatten';
import _replace from 'lodash/replace';

// initialState state
const getFiltersInitState = settings => {
	return settings.map((item, index) => {
		const suggest = {};

		item.suggest.forEach(item => {
			suggest[item.key] = Object.assign(item, {
				isOpenSelect: false,
				options: item.options || null,
				data: item.data || null,
				searchData: null,
				selectedItems: [],
				appliedItems: [],
				error: null,
				suggestQuery: ''
			});
		});

		return {
			id: ++index,
			title: item.title,
			isOpen: false,
			hasSelectedItems: false,
			hasAppliedItems: false,
			appliedItemsCount: 0,
			suggest,
			shouldHighlight: false,
			shouldHighlightChildren: false,
			customRender: item.customRender || null
		};
	});
};

const createFilters = ({
	namespace,
	stateNodeName,
	filtersInitialState
}) => {
	// action types
	const FILTER_TOGGLE = `${namespace}/${stateNodeName}-toggle`;
	const FILTER_FETCH_DATA_SUCCESS = `${namespace}/${stateNodeName}-fetch-data-success`;
	const FILTER_FETCH_DATA_ERROR = `${namespace}/${stateNodeName}-fetch-data-error`;
	const FILTER_TOGGLE_SELECT = `${namespace}/${stateNodeName}-toggle-select`;
	const FILTER_CHOOSE_ITEM = `${namespace}/${stateNodeName}-choose-item`;
	const FILTER_DELETE_ITEM = `${namespace}/${stateNodeName}-delete-item`;
	const FILTER_SUGGEST_ITEM = `${namespace}/${stateNodeName}-suggest-item`;
	const FILTER_APPLY = `${namespace}/${stateNodeName}-apply`;
	const FILTER_CLEAR = `${namespace}/${stateNodeName}-clear`;
	const FILTER_APPLY_BY_EXTERNAL_QUERY = `${namespace}/${stateNodeName}-apply-by-external-query`;
	const FILTER_TOGGLE_FILTER_HOVER = `${namespace}/${stateNodeName}toggle-filter-hover`;
	const FILTER_TOGGLE_CHILDREN_HOVER = `${namespace}/${stateNodeName}toggle-children-hover`;
	const FILTER_SET_OPTIONS_DATA = `${namespace}/${stateNodeName}-set-options-data`;
	const FILTER_REPLACE_STATE = `${namespace}/${stateNodeName}-replace-state`;

	// init state
	const initialState = getFiltersInitState(filtersInitialState);

	// actions
	const actions = {
		filterToggle: filterId => (dispatch, getState) => {
			dispatch({
				type: FILTER_TOGGLE,
				payload: filterId
			});

			// autofocus
			const currentFilter = find(getState()[`${namespace}`][stateNodeName], filter => filter.id === filterId);
			const suggestKeys = Object.keys(currentFilter.suggest);

			if (suggestKeys.length === 1) {
				const key = suggestKeys[0];
				const suggest = currentFilter.suggest[key];
				if (suggest.isOpenSelect === false) {
					dispatch(actions.filterInitSelect(filterId, key));
				}
			}
		},

		filterInitSelect: (filterId, suggestId) => (dispatch, getState) => {
			const currentFilter = find(getState()[`${namespace}`][stateNodeName], filter => filter.id === filterId);
			const suggest = currentFilter.suggest[suggestId];
			const { type, source } = suggest.options;

			if (type === 'fromServer') {
				actions.filterFetchData(filterId, suggestId, dispatch, getState);
			}

			if (type === 'fromInput') {
				dispatch(actions.filterToggleSelect(filterId, suggestId));
			}

			if (type === 'fromState') {
				const data = typeof source === 'function' ? source(getState()) : get(getState(), source);

				dispatch(actions.filterSetOptionsData(filterId, suggestId, data));
				dispatch(actions.filterToggleSelect(filterId, suggestId));
			}

			if (type === 'fromSource') {
				dispatch(actions.filterSetOptionsData(filterId, suggestId, source, false, false));
				dispatch(actions.filterToggleSelect(filterId, suggestId));
			}
		},

		filterToggleSelect: (filterId, suggestId) => ({
			type: FILTER_TOGGLE_SELECT,
			payload: {
				filterId,
				suggestId
			}
		}),

		filterFetchData: (filterId, suggestId, dispatch, getState) => {
			filterFetchRequest({ filterId, suggestId, dispatch, getState }, () =>
				dispatch(actions.filterToggleSelect(filterId, suggestId))
			);
		},

		filterChooseItem: (filterId, suggestId, itemId) => dispatch => {
			dispatch({
				type: FILTER_CHOOSE_ITEM,
				payload: {
					filterId,
					suggestId,
					itemId
				}
			});

			dispatch(actions.filterApply(filterId, false));
			dispatch(actions.filterToggleSelect(filterId, suggestId));
		},

		filterDeleteItem: (filterId, suggestId, itemId, selectedItems, shouldToggle) => dispatch => {
			dispatch({
				type: FILTER_DELETE_ITEM,
				payload: {
					filterId,
					suggestId,
					itemId
				}
			});

			dispatch(actions.filterApply(filterId, false));

			if (selectedItems.length === 1) {
				dispatch(actions.filterClear(filterId, false));
			}
		},

		filterSuggestItems: (filterId, suggestId, query) => (dispatch, getState) => {
			const currentFilter = find(getState()[`${namespace}`][stateNodeName], filter => filter.id === filterId);
			const suggest = currentFilter.suggest[suggestId];
			const { type, source } = suggest.options;

			if (type === 'fromServer') {
				const fetchRequestDebounce = debounce(filterFetchRequest, 300);
				fetchRequestDebounce({ filterId, suggestId, dispatch, getState, query });
			}

			if (type === 'fromInput') {
				dispatch(actions.filterSetOptionsData(
					filterId, suggestId, [{ id: query, text: query }]
				));
			}

			if (type === 'fromState') {
				const filterByQuery = (entity, query) => entity.text.toLowerCase().indexOf(query.toLowerCase()) > -1;
				const filterBySelected = (entity, selectedItems) => !find(selectedItems, {id: entity.id});
				const filteredData = suggest.data.filter(entity => (
					filterBySelected(entity, suggest.selectedItems) && filterByQuery(entity, query)
				));
				dispatch(actions.filterSetOptionsData(filterId, suggestId, filteredData, true));
			}

			if (type === 'fromSource') {
				dispatch(actions.filterSetOptionsData(filterId, suggestId, source, true, false));
			}

			dispatch({
				type: FILTER_SUGGEST_ITEM,
				payload: { filterId, suggestId, query }
			});
		},

		filterApply: (filterId, shouldToggle) => dispatch => {

			dispatch({
				type: FILTER_APPLY,
				payload: filterId
			});

			shouldToggle && dispatch(actions.filterToggle(filterId));
		},

		filterClear: (filterId, shouldToggle = true) => dispatch => {
			dispatch({
				type: FILTER_CLEAR,
				payload: filterId
			});

			shouldToggle && dispatch(actions.filterToggle(filterId));
		},

		filterApplyByExternalQuery: externalQuery => dispatch => {
			dispatch({
				type: FILTER_APPLY_BY_EXTERNAL_QUERY,
				payload: externalQuery
			});
		},

		filterToggleHighlight: filterId => ({
			type: FILTER_TOGGLE_FILTER_HOVER,
			payload: filterId
		}),

		filterToggleChildrenHighlight: filterId => ({
			type: FILTER_TOGGLE_CHILDREN_HOVER,
			payload: filterId
		}),

		filterSetOptionsData: (
			filterId, suggestId, rawData, shouldAddToSearch = false, isCapitalizeNeeded = true
		) => (dispatch, getState) => {
			const currentState = getState()[namespace][stateNodeName];
			const hasIdFilter = entity => !!entity.id;
			const formatter = entity => ({ id: entity.id, text: isCapitalizeNeeded ? capitalize(entity.text) : entity.text });

			const filters = currentState.map(item => {
				const cloneItem = cloneDeep(item);
				if (cloneItem.id === filterId) {
					const suggest = cloneItem.suggest[suggestId];
					const data = rawData && rawData.filter(hasIdFilter).map(formatter);

					suggest[shouldAddToSearch ? 'searchData' : 'data'] = data;
				}
				return cloneItem;
			});

			dispatch({
				type: FILTER_SET_OPTIONS_DATA,
				payload: filters
			});
		},

		// for cases when filters config needs to be dynamically created based on app data (user data etc)
		filterReplaceState: newFilterInitState => ({
			type: FILTER_REPLACE_STATE,
			payload: getFiltersInitState(newFilterInitState)
		})
	};

	// reducers
	const reducers = {
		[FILTER_TOGGLE]: (state, action) => {
			const filterId = action.payload;
			const filters = state.filters.map(filter => {
				const cloneFilter = cloneDeep(filter);
				cloneFilter.isOpen = cloneFilter.id === filterId ? !cloneFilter.isOpen : false;
				cloneFilter.shouldHighlightChildren = cloneFilter.id === filterId ? !filter.shouldHighlightChildren : false;
				cloneFilter.shouldHighlight = cloneFilter.id === filterId ? !filter.shouldHighlight : false;
				return cloneFilter;
			});
			return { ...state, filters };
		},

		[FILTER_FETCH_DATA_SUCCESS]: (state, action) => {
			const { filterId, suggestId } = action.payload.mixinData;
			const data = action.payload.data;
			const filters = state.filters.map(item => {
				const cloneItem = cloneDeep(item);
				if (cloneItem.id === filterId) {
					const suggest = cloneItem.suggest[suggestId];
					suggest.data =
						data &&
						data
							.filter(item => !!item.id)
							.map(item => {
								return suggest.key && (suggest.key === 'traffic_types' || suggest.key === 'statuses')
									? { id: item.id, text: capitalize(item.text) }
									: item;
							})
							.map(item => ({
								...item,
								text: _replace(item.text, new RegExp('%', 'g'), '%%')
							}));
				}
				return cloneItem;
			});
			return { ...state, filters };
		},

		[FILTER_TOGGLE_SELECT]: (state, action) => {
			const { filterId, suggestId } = action.payload;

			const filters = state.filters.map(filter => {
				const cloneFilter = cloneDeep(filter);
				if (cloneFilter.id === filterId) {
					for (let key in cloneFilter.suggest) {
						if (cloneFilter.suggest.hasOwnProperty(key)) {
							const suggest = cloneFilter.suggest[key];
							suggest.isOpenSelect = key === suggestId ? !suggest.isOpenSelect : false;
						}
					}
				}
				return cloneFilter;
			});

			return { ...state, filters };
		},

		[FILTER_CHOOSE_ITEM]: (state, action) => {
			const { filterId, suggestId, itemId } = action.payload;

			const filters = state.filters.map(filter => {
				const cloneFilter = cloneDeep(filter);
				if (cloneFilter.id === filterId) {
					const suggest = cloneFilter.suggest[suggestId];
					const chooseItem = find(suggest.data, item => item.id === itemId);

					suggest.selectedItems.push(chooseItem);
					suggest.suggestQuery = '';
					suggest.searchData = '';
					cloneFilter.hasSelectedItems = true;
				}
				return cloneFilter;
			});

			return { ...state, filters };
		},

		[FILTER_DELETE_ITEM]: (state, action) => {
			const { filterId, suggestId, itemId } = action.payload;
			const filters = state.filters.map(filter => {
				const cloneFilter = cloneDeep(filter);
				if (cloneFilter.id === filterId) {
					let hasSelectedItems = false;

					for (let key in cloneFilter.suggest) {
						if (cloneFilter.suggest.hasOwnProperty(key)) {
							const suggest = cloneFilter.suggest[key];
							if (suggestId === key) {
								suggest.selectedItems = filterBy(suggest.selectedItems, item => item.id !== itemId);
							}
							if (suggest.selectedItems.length) {
								hasSelectedItems = true;
							}
						}
					}

					// cloneFilter.isOpen = hasSelectedItems;
					cloneFilter.hasSelectedItems = hasSelectedItems;
					cloneFilter.shouldHighlight = false;
				}
				return cloneFilter;
			});
			return { ...state, filters };
		},

		[FILTER_APPLY]: (state, action) => {
			const filterId = action.payload;
			const filters = state.filters.map(filter => {
				const cloneFilter = cloneDeep(filter);
				if (cloneFilter.id === filterId) {
					let appliedCount = 0;
					for (let key in cloneFilter.suggest) {
						if (cloneFilter.suggest.hasOwnProperty(key)) {
							const suggest = cloneFilter.suggest[key];
							if (suggest.selectedItems.length) {
								suggest.appliedItems = cloneDeep(suggest.selectedItems);
								appliedCount += suggest.appliedItems.length;
							}
						}
					}
					cloneFilter.hasAppliedItems = true;
					cloneFilter.appliedItemsCount = appliedCount;
				}
				return cloneFilter;
			});
			return { ...state, filters };
		},

		[FILTER_CLEAR]: (state, action) => {
			const filterId = action.payload;
			const filters = state.filters.map(filter => {
				const cloneFilter = cloneDeep(filter);
				if (cloneFilter.id === filterId) {
					for (let key in cloneFilter.suggest) {
						if (cloneFilter.suggest.hasOwnProperty(key)) {
							const suggest = cloneFilter.suggest[key];
							suggest.selectedItems = [];
							suggest.appliedItems = [];
						}
					}
					cloneFilter.hasAppliedItems = false;
					cloneFilter.hasSelectedItems = false;
					cloneFilter.appliedItemsCount = 0;
				}
				return cloneFilter;
			});
			return { ...state, filters };
		},

		[FILTER_SUGGEST_ITEM]: (state, action) => {
			const { filterId, suggestId, query } = action.payload;
			const filters = state.filters.map(filter => {
				const cloneFilter = cloneDeep(filter);
				if (cloneFilter.id === filterId) {
					const suggest = cloneFilter.suggest[suggestId];
					suggest.suggestQuery = query;
				}
				return cloneFilter;
			});
			return { ...state, filters };
		},
		[FILTER_APPLY_BY_EXTERNAL_QUERY]: (state, action) => {
			const filters = state.filters.map(filter => {
				const cloneFilter = cloneDeep(filter);
				const externalFilters = action.payload && action.payload.filters;
				const externalQueryFiltersKeys = (externalFilters && Object.keys(externalFilters)) || [];

				let appliedCount = 0;
				let shouldSetAppliedStatus = false;

				for (let key in cloneFilter.suggest) {
					if (cloneFilter.suggest.hasOwnProperty(key) && indexOf(externalQueryFiltersKeys, key) !== -1) {
						const suggest = cloneFilter.suggest[key];
						suggest.selectedItems = externalFilters[key];
						suggest.appliedItems = externalFilters[key];
						appliedCount += externalFilters[key].length;
						shouldSetAppliedStatus = true;
					}
				}

				if (shouldSetAppliedStatus) {
					cloneFilter.hasAppliedItems = true;
					cloneFilter.hasSelectedItems = true;
					cloneFilter.appliedItemsCount = appliedCount;
				}
				return cloneFilter;
			});
			return { ...state, filters };
		},
		[FILTER_TOGGLE_FILTER_HOVER]: (state, action) => {
			const filterToUpdateId = action.payload;
			return {
				...state,
				filters: state.filters.map(filter => {
					const cloneFilter = cloneDeep(filter);
					if (cloneFilter.id === filterToUpdateId && !cloneFilter.isOpen ) {
						cloneFilter.shouldHighlight = !filter.shouldHighlight;
					}
					return cloneFilter;
				})
			};
		},
		[FILTER_TOGGLE_CHILDREN_HOVER]: (state, action) => {
			const filterToUpdateId = action.payload;
			return {
				...state,
				filters: state.filters.map(filter => {
					const cloneFilter = cloneDeep(filter);
					if (cloneFilter.id === filterToUpdateId) {
						cloneFilter.shouldHighlightChildren = cloneFilter.isOpen ? true: !filter.shouldHighlightChildren;
					}
					return cloneFilter;
				})
			};
		},

		[FILTER_SET_OPTIONS_DATA]: (state, action) => ({...state, filters: action.payload }),

		[FILTER_REPLACE_STATE]: (state, action) => ({...state, filters: action.payload })
	};

	// selectors
	const selectors = {
		selectFilters: (filterSelector, appState) =>
			createSelector(filterSelector, appState, (filters, appState) => {
				let opened = find(appState[`${namespace}`].filters, filter => filter.isOpen);

				if (opened) {
					opened = cloneDeep(opened);
					forEach(opened.suggest, item => {
						const selectedItemsIds = item.selectedItems.map(item => item.id);
						if (selectedItemsIds.length) {
							item.data = filterBy(item.data, item => indexOf(selectedItemsIds, item.id) === -1);
						}
					});
				}

				return {
					list: appState[`${namespace}`].filters,
					opened
				};
			}),

		appliedFilters: state => {
			const filters = state[namespace][stateNodeName];
			const appliedFilters = {};

			forEach(filters, filter => {
				if (filter.hasAppliedItems) {
					for (let key in filter.suggest) {
						if (filter.suggest.hasOwnProperty(key)) {
							const suggest = filter.suggest[key];
							const appliedItems = cloneDeep(suggest.appliedItems);

							appliedFilters[key] = appliedItems.map(entity => ({
								itemId: entity.id,
								text: entity.text,
								filterId: filter.id,
								suggestId: suggest.key,
								suggestAppliedItems: suggest.appliedItems,
								shouldHighlight: filter.shouldHighlightChildren
							}));
						}
					}
				}
			});

			return flatten(values(appliedFilters));

		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};

	function filterFetchRequest(options, afterRequestAction = null) {
		const { filterId, suggestId, dispatch, getState, query = '' } = options;
		const master_filter_config = find(getState().statistics.masterSwitchConfig, { active: true }).id;
		const state = getState();
		const balance = state.app && state.app.userData && state.app.userData.activeBalance;
		const context = qs.stringify(getRequestQuery(state[`${namespace}`], balance));
		const currentFilter = find(getState()[`${namespace}`].filters, filter => filter.id === filterId);
		const suggest = currentFilter.suggest[suggestId];
		const url = suggest.options.source;
		const requestQuery = suggest.options.requestQuery || '';

		const request = http({
			url: `${url}?${requestQuery || context}&query=${query}&master_filter_config=${master_filter_config}`,
			method: 'get',
			actions: [FILTER_FETCH_DATA_SUCCESS, FILTER_FETCH_DATA_ERROR],
			addToResponse: {
				filterId,
				suggestId
			}
		});

		request(dispatch).then(afterRequestAction);
	}
};

export default createFilters;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/filters/index.js